import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../../utils/constants';

export default function GlobalBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    {
      id: 'leaderboard',
      label: 'Leaderboard',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
      path: ROUTES.LEADERBOARD,
      action: 'navigate'
    },
    {
      id: 'scoring',
      label: 'Scoring',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
      ),
      path: ROUTES.SCORING,
      action: 'navigate'
    },
    {
      id: 'members',
      label: 'Members',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
      path: ROUTES.MEMBERS,
      action: 'navigate'
    },
    {
      id: 'history',
      label: 'History',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      path: ROUTES.HISTORY,
      action: 'navigate'
    }
  ];

  const handleTabClick = (tab) => {
    if (tab.action === 'navigate') {
      navigate(tab.path);
    }
  };

  const isActive = (tab) => {
    if (tab.action === 'navigate') {
      // Check if current path matches tab path
      if (location.pathname === tab.path) return true;

      // Special handling for leaderboard/scoring tabs when viewing active round
      if (tab.id === 'leaderboard' && location.pathname.startsWith('/rounds/')) {
        const activeTab = location.state?.activeTab || 'leaderboard';
        return activeTab === 'leaderboard';
      }
      if (tab.id === 'scoring' && location.pathname.startsWith('/rounds/')) {
        const activeTab = location.state?.activeTab || 'leaderboard';
        return activeTab === 'enter-scores';
      }
    }
    return false;
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-top z-50 safe-area-bottom">
      <div className="flex justify-around items-center">
        {tabs.map((tab) => {
          const active = isActive(tab);
          return (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab)}
              className={`flex flex-col items-center justify-center py-2 px-4 min-h-[60px] flex-1 transition-colors ${
                active
                  ? 'text-primary bg-sand'
                  : 'text-gray-600 hover:text-primary hover:bg-sand/50'
              }`}
            >
              <div className={`${active ? 'text-primary' : 'text-gray-600'}`}>
                {tab.icon}
              </div>
              <span className={`text-xs font-semibold mt-1 ${active ? 'text-primary' : 'text-gray-600'}`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
